import { FormContextType, RJSFSchema, StrictRJSFSchema, TitleFieldProps } from '@rjsf/utils';

/** The `TitleField` is the template to use to render the title of a field
 *
 * @param props - The `TitleFieldProps` for this component
 */
function TitleFieldTemplate<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>({
	id,
	required,
	registry,
	title,
}: TitleFieldProps<T, S, F>) {
	const { formContext } = registry;
	const { colon = true } = formContext;

	let labelChildren = title;
	if (colon && typeof title === 'string' && title.trim() !== '') {
		labelChildren = title.replace(/[：:]\s*$/, '');
	}

	const handleLabelClick = () => {
		if (!id) {
			return;
		}

		const control: HTMLLabelElement | null = document.querySelector(`[id="${id}"]`);
		if (control && control.focus) {
			control.focus();
		}
	};

	if (!title) {
		return null;
	}

	return null;
}

export { TitleFieldTemplate };
